import { report } from "./checks.ts";
import type { RulesProblem } from "./types.ts";

/**
 * The check that reads the travel fare's Focus constants against one another (ADR-137's amendment of 2026-10-28): each
 * constant's own bounds are its record's, and this runs across the constants after their records.
 */

/**
 * Checks that the Focus cap from anywhere is at least its base, so the cap never lowers the share of the shortest trip.
 * A constant its own record refused is not compared.
 *
 * @param base The checked `travel_anywhere_focus_percent`, or null when the constants hold none that passed.
 * @param cap The checked `travel_anywhere_focus_cap`, or null likewise.
 * @param problems Where problems go.
 */
export function checkTravelFocus(base: number | null, cap: number | null, problems: RulesProblem[]): void {
  if (base !== null && cap !== null && cap < base) {
    report({ table: "constants", id: "travel_anywhere_focus_cap", problems }, `count is ${cap}, and it must be at least travel_anywhere_focus_percent, ${base}`);
  }
}
